import { writable } from 'svelte/store';

export type NavPopover = ReturnType<typeof createNavPopover>;

export const createNavPopover = () => {
	const open = writable(false);

	return {
		states: { open },
		close: () => open.set(false),
		open: () => open.set(true)
	};
};
